<div #animatedDigit class="progress-percentage">
	{{digit}}
</div>
